// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1J4Bq","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__262hN"};